type ChevronRight2Props = {
  className?: string;
};

const ChevronRight2 = ({ className }: ChevronRight2Props) => (
  <svg
    width="10"
    height="18"
    viewBox="0 0 10 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M1 1L9 9L1 17" stroke="black" stroke-linecap="round" />
  </svg>
);

export default ChevronRight2;
